import React, { useEffect, useState } from 'react';
import { getResultOrigin } from '../../dataProvider/origin';

import './tickerContainer.scss';
import Ticker from '../../components/ticker';
import { ResultProvider } from '../../dataProvider/results/index';
import { TYPES, SUBTYPES } from '../../envs/core';
const TickerContainer = ({ match }) => {
  const { year, type, electionNumber, placesIds } = match.params;

  const [resultOrigin, setResultOrigin] = useState({});

  useEffect(() => {
    getResultOrigin(year, type, electionNumber, placesIds)
      .then(historicResult => {
        setResultOrigin(historicResult);
      })
      .catch(err => {
        
      });
  }, [year, type, electionNumber]);
  return (
    <div>
      {resultOrigin && resultOrigin.primary && (
        <ResultProvider
          electionPlace={placesIds}
          active={resultOrigin.primary.active}
          year={year}
          type={type}
          subtype={type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE}
          electionNumber={electionNumber}
          placeId={placesIds}
        >
          {congressData => (
            <ResultProvider
              electionPlace={placesIds}
              active={resultOrigin.primary.active }
              year={year}
              type={type}
              subtype={
                type === TYPES.GENERAL ? SUBTYPES.SENATE : SUBTYPES.SINGLE
              }
              electionNumber={electionNumber}
              placeId={placesIds}
            >
              {senateData => (
                  <Ticker
                    congressAndSenateResults={{
                      senate: congressData,
                      congress: congressData
                    }}
                  />
              )}
            </ResultProvider>
          )}
        </ResultProvider>
      )}
    </div>
  );
};

export default TickerContainer;
